import { render, staticRenderFns } from "./m-addSelectionSNPMB.vue?vue&type=template&id=93309a52&"
import script from "./m-addSelectionSNPMB.vue?vue&type=script&lang=js&"
export * from "./m-addSelectionSNPMB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports